import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { INPUT_ID } from './constants';
import classes from './index.module.scss';
import { InputProps } from './types';

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      type = 'text',
      disabled = false,
      isSuccess = false,
      isError = false,
      hideNumberSpinButton = false,
      ...rest
    },
    ref
  ) => {
    const inputClassName = classnames(
      classes.input,
      {
        [classes.success]: isSuccess,
        [classes.error]: isError,
        [classes.hideNumberSpinButton]: type === 'number' && hideNumberSpinButton,
      },
      className
    );

    const inputProps = {
      disabled,
      type,
      ref,
      ...rest,
    };

    return <input className={inputClassName} {...inputProps} />;
  }
);

Input.displayName = 'Input';

Object.assign(Input, {
  id: INPUT_ID,
});

export default Input;
